// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__wT8ne","header__notifications":"styles_header__notifications__3rILI","header__profile":"styles_header__profile__1nE9A","logo":"styles_logo__3Q0fa"};